import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { trigger, style, animate, transition, query, stagger, keyframes, state, group } from '@angular/animations';
import { CommonService } from "../common.service";
import { ApiService} from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import {StoreService} from '../store.service';
declare var $: any;

@Component({
  selector: 'app-case-practice-team-report',
  animations: [
    trigger('textBoxAnimation', [
      transition(':enter', [
        group([
          query('div#textBox', [
            style({transform: 'scale(1, 1)', opacity: 0}),
            animate('500ms', keyframes([
                style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
                style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
                style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
                style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
                style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
                style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
                style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
                style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
                style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
                style({transform: 'scale(1, 1)', opacity: 1})
              ])
            )
          ]),
          query('div#nextBtn', [style({opacity: 0}), animate('500ms', keyframes([
                style({opacity: 0}),
                style({opacity: 0.2}),
                style({opacity: 0.4}),
                style({opacity: 0.6}),
                style({opacity: 0.8}),
                style({opacity: 1})
              ])
            )
          ]),
        ]),
        group([
          query('img#arrow_right_1', [animate('2s', keyframes([
                 style({transform: 'translate(0%)'}),
                 style({transform: 'translate(25%)'}),
                 style({transform: 'translate(50%)'}),
                 style({transform: 'translate(25%)'}),
                 style({transform: 'translate(0)'})
              ])
            )
          ]),
          query('img#arrow_right_2', [animate('2s', keyframes([
                style({transform: 'translate(0%)'}),
                style({transform: 'translate(25%)'}),
                style({transform: 'translate(50%)'}),
                style({transform: 'translate(25%)'}),
                style({transform: 'translate(0%)'})
              ])
            )
          ])
        ])
      ]),
      transition(':leave', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0})
        ]))
      )
    ]),
    trigger('tourReviewAnimation', [
      state('showTourReview', style({opacity: 1, left: '3.8rem', top: '7rem'})),
      state('hideTourReview', style({opacity: 0, left: '5.2rem', top: '-0.5rem', zIndex:-1})),
      transition('showTourReview => hideTourReview', animate('0ms', keyframes([
          style({transform: 'scale(1, 1)', left: '3.9rem', top: '7rem'}),
          style({transform: 'scale(0.9, 0.9)', left: '4.1rem', top: '5.5rem'}),
          style({transform: 'scale(0.8, 0.8)', left: '4.3rem', top: '4rem'}),
          style({transform: 'scale(0.7, 0.7)', left: '4.5rem', top: '2.5rem'}),
          style({transform: 'scale(0.6, 0.6)', left: '4.7rem', top: '1rem'}),
          style({transform: 'scale(0.5, 0.5)', left: '4.9rem', top: '-0.5rem'})
        ]))
      )
    ]),
    trigger('subWrapTwoAnimation', [
      state('showSubWrapTwo', style({opacity: 1, transform: 'translate(0%)'})),
      state('hideSubWrapTwo', style({opacity: 0, transform: 'translate(300%)'})),
      transition('hideSubWrapTwo => showSubWrapTwo', animate('500ms', keyframes([
          style({transform: 'translate(100%)', opacity: 0.1}),
          style({transform: 'translate(80%)', opacity: 0.2}),
          style({transform: 'translate(60%)', opacity: 0.4}),
          style({transform: 'translate(40%)', opacity: 0.6}),
          style({transform: 'translate(20%)', opacity: 0.8}),
          style({transform: 'translate(0%)', opacity: 1})
        ]))
      )
    ]),
    trigger('btnWrapAnimation', [
      state('showButtonWrap', style({opacity: 1, transform: 'translate(0%, 0%)'})),
      state('hideButtonWrap', style({opacity: 0, transform: 'translate(0%, 200%)'})),
      transition('hideButtonWrap => showButtonWrap', animate('1s', keyframes([
          style({transform: 'translate(0%, 100%)', opacity: 0.1}),
          style({transform: 'translate(0%, 80%)', opacity: 0.2}),
          style({transform: 'translate(0%, 60%)', opacity: 0.4}),
          style({transform: 'translate(0%, 40%)', opacity: 0.6}),
          style({transform: 'translate(0%, 20%)', opacity: 0.8}),
          style({transform: 'translate(0%, 0%)', opacity: 1})
        ]))
      )
    ]),
    trigger('tourReviewBoxAnimation', [
      state('hideTourReviewBox', style({opacity: 0, transform: 'scale(0.1, 0.1)'})),
      state('showTourReviewBox', style({opacity: 1, transform: 'scale(1, 1)'})),
      transition('hideTourReviewBox => showTourReviewBox', animate('1s', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))
      ),
      transition('showTourReviewBox => hideTourReviewBox', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0})
        ]))
      )
    ]),
    trigger('bestPathBoxAnimation', [
      state('hideBestPathBox', style({opacity: 0, transform: 'scale(0, 0)'})),
      state('showBestPathBox', style({opacity: 1, transform: 'scale(1, 1)'})),
      transition('hideBestPathBox => showBestPathBox', animate('200ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))
      ),
      transition('showBestPathBox => hideBestPathBox', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0})
        ]))
      )
    ]),
    trigger('analysisBoxAnimation', [
      state('hideAnalysisBox', style({opacity: 0, transform: 'translate(-100%)'})),
      state('showAnalysisBox', style({opacity: 1})),
      transition('hideAnalysisBox => showAnalysisBox', animate('200ms', keyframes([
          style({transform: 'matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '45%'}),
          style({transform: 'matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '47%'}),
          style({transform: 'matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '49%'}),
          style({transform: 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '50%'})
          ])
        )
      ),
      transition('showAnalysisBox => hideAnalysisBox', animate('500ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0})
      ])))
    ]),
    trigger('starAnimation', [
      state('hideStar', style({opacity: 0})),
      state('showStar', style({opacity: 1})),
      transition('hideStar => showStar', [
        style({opacity: 1}),
        query('.starReport', style({opacity: 0})),
        query('.starReport5', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport4', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport3', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport2', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport1', animate('200ms', style({opacity: 1})), { optional: true })
      ])
    ])
  ],
  templateUrl: './case-practice-team-report.component.html',
  styleUrls: ['./case-practice-team-report.component.css',]
})
export class CasePracticeTeamReportComponent implements OnInit, AfterViewInit {

    multiExerciseMetaId: any;
    learningPathId: any;
    learningPathMetaId: any;
    learningPath: any;
    learningTour: any;
    // chuanjie: any;
    report: any;

  //报告等级KA对象：传递给等级组件
    reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

    currentName: any;
    currentTotal: any;
    currentDescription: any;
    currentAnalysis: any;

    subWrapTwoShow: boolean;
    btnWrapShow: boolean;
    tourReviewShow: boolean;
    tourReviewBoxShow: boolean;
    bestPathBoxShow: boolean;
    analysisBoxShow: boolean;
    starShow: boolean;
    pathClickable: boolean;
    redoClickedStatus: boolean;
    goToListClickedStatus: boolean;

    practiceMetaId:any;
  assetsRoute: string = "../../assets";
    type : string


  constructor(private commonService:CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router,
              private storeService:StoreService) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
     let that = this;
      this.isShowReportLv = false;
      this.subWrapTwoShow = true;
      this.btnWrapShow = true;
      this.tourReviewShow = true;
      this.tourReviewBoxShow = false;
      this.bestPathBoxShow = false;
      this.analysisBoxShow = false;
      this.starShow = false;
      this.pathClickable = true;
      this.redoClickedStatus = false;
      this.goToListClickedStatus = false;
      this.route.queryParams.subscribe(queryParams=>{
        this.type=queryParams['type']
      })
      this.route.params.subscribe(params => {
          this.multiExerciseMetaId = params['multiExerciseMetaId'];
          this.learningPathId = params['learningPathId'];
          this.practiceMetaId = params['practiceMetaId'];
          this.apiService.ajax({
              'type':'get',
              'url':'/api/multiFinish/'+this.multiExerciseMetaId
          }).subscribe(result=>{
                this.report = result;

            $.ajax({
              url: "/sr/insideapi/getlevel",
              // url: "http://47.96.183.37:10050/ddi/insideapi/getlevel",
              type: "post",
              dataType:'json',
              contentType:'application/json;charset=utf-8',
              data:JSON.stringify(this.getKaList(result) ),
              async: false,
              headers : {
                'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
              },
              success:function(result){
                if(result && result != ""){
                  that.reportKAData = result;
                  that.targetShow = 1;
                }else{
                  that.targetShow = 0;
                }
              },
              error:function(er){
                that.targetShow = 0;
                if(er.status === 401 && Number(er.responseJSON.code) === 106){
                  that.storeService.notification.notAuthed.next(true);
                }
              }
            });

            if(that.targetShow === 0){
              this.isShowReportLv = false;
            }else{
              this.isShowReportLv = true;
            }
                // this.reportKAData = this.getKaList(result);
                // this.isShowReportLv = true;
          });

          /*this.report = this.getMockData();
          this.chuanjie = 'test';
          console.log(this.report);*/
      });

      this.apiService.ajax({
          'type':'get',
          'url': '/sr/learningtour',
      }).subscribe(result=>{
          this.learningTour = result;
      });

      // this.apiService.ajax({
      //   'type': 'get',
      //   'url': '/api/concatenation/' + this.learningPathId,
      //   'data': {
      //     'learningPathId': this.learningPathId,
      //   }
      // }).subscribe(comment => { this.chuanjie = comment[2].comment; });

  }

  ngAfterViewInit(){
    let that = this;
    this.commonService.initPage({
        'backgroundColor':'white'
    });
    $(document).ready(function(){
      var listenerTimeout = setInterval(function(){
        var bestPathEle = document.getElementById('bestPathBox'),
            analysisEle =  document.getElementById('analysisContent'),
            tutorEle = document.getElementById('tourReviewBox');
        if(bestPathEle !== null && analysisEle !== null && tutorEle != null){
          bestPathEle.addEventListener('scroll', that.onBestPathScroll);
          analysisEle.addEventListener('scroll', that.onAnalysisScroll);
          tutorEle.addEventListener('scroll', that.onTutorScroll);
          clearInterval(listenerTimeout);
        }
      }, 500);
    });


  }


  /*
  格式化KA对象方法
   report：传递一个报告对象
 */
	getKaList(report){
		let kaJson = {id:this.learningPathId,name:"打造高效团队",type:"exercise",kas:{},exercisesId:this.practiceMetaId,questionId:null,optionId:null};
		if(report){
			for(let i = 1;i <= 6; i++){
				let kaItem = report["ka" + i];
				if(kaItem){
					//kaJson.kas.push({name:kaItem.name,value:kaItem.total});
					kaJson.kas[kaItem.name] = kaItem.total;
				}
			}
		}
		return kaJson;
	}

  close(){
    let link = ['case-practice-team',this.learningPathId,this.practiceMetaId, 1, 0];
    if(this.type){
      this.router.navigate(link,{queryParams:{type:'huatek'}});
    }else{
        this.router.navigate(link);
    }
  } // end of close

  redo(){

    if(!this.pathClickable || this.redoClickedStatus){
      return;
    }else{
      this.redoClickedStatus = true;
    }

    this.apiService.ajax({
        'type':'get',
        'url':'/api/multi/'+this.multiExerciseMetaId+'/reset'
    }).subscribe(result=>{
    	let link = ['case-practice-team-begin',this.multiExerciseMetaId,this.learningPathId,this.practiceMetaId];
      if(this.type){
        this.router.navigate(link,{queryParams:{type:'huatek'}});
      }else{
          this.router.navigate(link);
      }
    });


  } // end of redo

  onBestPathScroll(){
    var overlay = document.getElementById('bestPathBox');
    if (overlay.scrollTop < 1) {
        overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1)                         {
        overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onAnalysisScroll(){
    var overlay = document.getElementById('analysisContent');
    if (overlay.scrollTop < 1) {
        overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1)                         {
        overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onTutorScroll(){
    var overlay = document.getElementById('tourReviewBox');
    if (overlay.scrollTop < 1) {
        overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1)                         {
        overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  subWrapOneOut(){
    // $('#subWrapOne').fadeOut(function () {
    //     $('#subWrapTwo').fadeIn();
    // });
    let _this = this;
    $('#subWrapOne').fadeOut(200);
    $('#subWrapTwo').show();
    this.tourReviewShow = false;
    setTimeout(function(){

      _this.subWrapTwoShow = true;
      _this.btnWrapShow = true;
      _this.pathClickable = true;

    }, 500);

  }

  tourReviewBoxOut(){

    $('#tourReviewShade').fadeOut();
    this.tourReviewBoxShow = false;
    $('#closeBtn1').fadeOut();
    this.pathClickable = true;
  }

  tourReviewBoxIn(){

    this.pathClickable = false;
    $('#tourReviewShade').fadeIn();
    // $('#tourReviewBox').fadeIn();
    this.tourReviewBoxShow = true;
    $('#closeBtn1').fadeIn();


  }

  bestPathIn(){
    if(!this.pathClickable){
      return;
    }
    // $('#bestPathBox').fadeIn();
    $('#closeBtn2').fadeIn();
    this.bestPathBoxShow = true;
    $('#shade').fadeIn();

  }

  slideBestPathBox(dom){
	  let target = $(dom).find('.sectionSlideTxt').text();
    let cls = $(dom).data('target');

	  if(target === '展开'){
      $(dom).find('.sectionSlideTxt').text('收起');
      $(dom).find('.sectionSlideTriangle').addClass('rotate180');
	    $('.'+cls).removeClass('hidden');
      $(dom).find('.sectionIcon').removeClass('opacity100');
    }else{
	      let scrollDistance = $('.'+cls).offset().top-$('#bestPathBox').offset().top+$('#bestPathBox').scrollTop();
      $('#bestPathBox').animate({
        scrollTop: scrollDistance
      },500);
	    // $('#bestPathBox').scrollTop(scrollDistance);
      $(dom).find('.sectionSlideTxt').text('展开');
      $(dom).find('.sectionSlideTriangle').removeClass('rotate180');
      $('.'+cls).addClass('hidden');
      $(dom).find('.sectionIcon').addClass('opacity100');
    }

  }

  bestPathOut(){
    // $('#bestPathBox').fadeOut();
    $('#closeBtn2').fadeOut();
    this.bestPathBoxShow = false;
    $('#shade').fadeOut();

  }

  analysisBoxIn(i){

    let _this = this;
    this.pathClickable = false;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].total;
    this.currentAnalysis = this.report[i].analysis;
    $('#analysisShade').fadeIn();
    $('#analysisShade').fadeIn();
    // $('#analysisBox').fadeIn();
    $('#analysisContent').scrollTop(0);
    this.analysisBoxShow = true;
    // $('#subWrapTwo').css({'overflow':'hidden'});
    // $('body').css('overflow-y', 'hidden');
    setTimeout(function(){

      _this.starShow = true;

    }, 300);

  }

  analysisBoxOut(){

      $('#analysisShade').fadeOut();
      this.analysisBoxShow = false;
      // $('body').css('overflow-y', 'scroll');
      this.starShow = false;
      this.pathClickable = true;

  }

  goToList(){
    if(this.goToListClickedStatus || !this.pathClickable){
      return;
    } else{
      this.goToListClickedStatus = true;
    }
    let link = ['case-practice-team', this.learningPathId, this.practiceMetaId, 1, this.multiExerciseMetaId];
    if(this.type){
      this.router.navigate(link,{queryParams:{type:'huatek'}});
    }else{
        this.router.navigate(link);
    }
  }

  linkToPostSurvey(){
    this.apiService.ajax({
      'type': 'get',
      'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
    }).subscribe(result=>{
      this.learningPathMetaId = result.data;
      this.apiService.getOrCreateLearningPath(this.learningPathMetaId).subscribe(result=>{
        this.learningPath = result;
        if(this.learningPath.subItems.length==3){
          this.apiService.ajax({
            'type':'get',
            'url': '/sr/learningtour',
          }).subscribe(result=>{
            this.learningTour = result;
            let link = ['survey', this.learningTour.tour_id, 3,2];
            this.router.navigate(link);
          });
        }else{

          let link = ['survey', this.learningPath.id, this.learningPath.subItems[4].surveyMetaId,1];
          this.router.navigate(link);

        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-team-report/case-practice-team-report.component.ts